import { OutputEmitterRef } from '@angular/core';
import { UserContextService } from '../../../../../user-management';
import {
  ActionTypeHandlerBaseSmartEnum,
  ActionTypeEnum,
  ActionTypeBaseSmartEnum,
  IDialogActionConfig,
  ActionTypeHandlerEnum
} from '../enums';
import { IActionConfig, IActionExecutedEvent } from '../types';

export class ActionConfigManager<TEntity, TComponentType = unknown, TData = unknown> {
  config: IActionConfig<TEntity, TComponentType, TData>;
  handler: ActionTypeHandlerBaseSmartEnum;
  isItemAction: boolean = false;

  constructor(config: IActionConfig<TEntity, TComponentType, TData>) {
    this.config = config;
    this.handler = this.getConfigHandler();
    this.isItemAction = config.type !== ActionTypeEnum.CREATE;
  }

  static create<TEntity, TComponentType = unknown, TData = unknown>(
    config: IActionConfig<TEntity, TComponentType, TData>
  ) {
    let configManager = new ActionConfigManager(config);
    configManager.setDefaultIconAndLabel();
    return configManager;
  }

  static createDefaultDialog() {}

  setDefaultIconAndLabel() {
    if (!!this.config.icon && !!this.config.label) {
      return;
    }

    let actionType = ActionTypeBaseSmartEnum.fromName<ActionTypeBaseSmartEnum>(this.config.type);

    if (this.config.type === ActionTypeEnum.CUSTOM || !actionType) {
      throw new Error(`You have to specify the icon and label for any custom action`);
    }

    this.config.icon = this.config.icon || actionType.defaultIcon;
    this.config.label = this.config.label || actionType.defaultLable;
  }

  canUse(): boolean {
    return UserContextService.hasPermission(this.config.permission);
  }

  execute(item?: TEntity, actionExecuted?: OutputEmitterRef<IActionExecutedEvent<TEntity>>, onClose?: () => void) {
    if (!this.canUse()) {
      throw new Error(`The logged in user can't use this action`);
    }

    let handler = this.getConfigHandler();

    this.attachOnCloseIfDialog(onClose);

    handler.execute(this.config, item, actionExecuted);
  }

  private getConfigHandler(): ActionTypeHandlerBaseSmartEnum {
    let handler = ActionTypeHandlerBaseSmartEnum.fromName<ActionTypeHandlerBaseSmartEnum>(this.config.handlerType);

    if (!handler) {
      throw new Error(`Their is no handler supported for this actionType: ${this.config.type}`);
    }

    return handler;
  }

  private attachOnCloseIfDialog(onClose?: () => void) {
    if (!onClose || !this.isDialogConfig(this.config)) return;

    this.config.handlerConfig.onClose = onClose;
  }

  private isDialogConfig(config: IActionConfig<TEntity>): config is IDialogActionConfig<TEntity> {
    return config.handlerType === ActionTypeHandlerEnum.DIALOG;
  }
}
